export default __webpack_public_path__ + "static/media/redux-icon.d81fad54.svg";